import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getChapterProofsOptions,
  useDeleteChapterProof,
  useUploadOrUpdateChapterProof,
} from './model/ChapterProofModel';

interface ChapterProofActionProps {
  chapterId: number;
  authors: Author[];
  variant?: 'compact';
}

export function ChapterProofAction({ chapterId, authors }: ChapterProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getChapterProofsOptions(chapterId));
  const uploadOrUpdateMutation = useUploadOrUpdateChapterProof(chapterId);
  const deleteMutation = useDeleteChapterProof(chapterId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="chapter"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
